import { ApolloClient, gql } from '@apollo/client';

import { useOnce } from '@utils/hooks/use_once';

type PrefetchedQuery = {
  query: string;
  variables?: Record<string, any>;
  data: Record<string, any>;
};

declare global {
  interface Window {
    __PREFETCHED_GQL__?: PrefetchedQuery[];
  }
}

export function useHydrateApolloCache(client: ApolloClient) {
  useOnce(() => {
    if (!window.__PREFETCHED_GQL__) return;

    window.__PREFETCHED_GQL__.forEach(({ query, data, variables }) => {
      if (data) {
        client.writeQuery({
          query: gql(query),
          variables,
          data,
        });
      }
    });
  });
}
